export enum TransactionStatus {
  COMPLETED = 'completed',
  IN_PROGRESS = 'in_progress',
  REJECTED= 'rejected',
}
